// hooks
import useLocales from "hooks/useLocales";

// helpers
import TwoColWithTextAndPreviewCard from "components/features/TwoColWithTextAndPreviewCard";

// sections
import BaseSolutionPage from "./BaseSolutionPage";
import Markdown from "components/markdown/Markdown";

export default () => {
  const { t, currentLang } = useLocales();

  const headingText = t("jmtAssetManagement.title");

  return (
    <BaseSolutionPage
      headingText={headingText}
      category="erpSolutions.operational"
    >
      <TwoColWithTextAndPreviewCard
        textContent={<Markdown children={getContent(currentLang)} />}
        btnViewText={t("buttons.view")}
        card={null}
      />
    </BaseSolutionPage>
  );
};

function getContent(currentLang) {
  if (currentLang?.value === "en") return enContent;
  return viContent;
}

const enContent = `
TBU
`;

const viContent = `
*   Quản lý danh mục thiết bị và trạng thái.
*   Tích hợp hệ thống quản lý nhân sự - phân quyền quản lý thiết bị.
*   Kiểm soát & phê duyệt thông qua website quản trị và ứng dụng điện thoại.
*   Tuỳ chỉnh chức năng theo yêu cầu đặc thù của doanh nghiệp.
`;
